<template>
  <div class="p-b-10">
    <popover
      v-model="showModal"
      custom-class="search-popover"
      placement="bottom"
      trigger="manual"
      :auto-placement="false"
    >
      <input
        v-model="numberSearchedModel"
        v-tooltip.focus="'Press Enter to Search'"
        class="form-control widget-header-input max-width-200"
        :disabled="showModal"
        placeholder="Search Bulk Blocked Number"
        type="text"
        oninput="validity.valid||(value='')"
        @keyup.enter="onSearchNumber"
      >
      <template slot="popover">
        <SearchBulkBlockedNumberModal
          v-on-clickaway="hideModal"
          :searched-number="numberSearched"
          :campaigns-map="campaignsMap"
          @unblock-number="onUnblock"
          @hide-modal="hideModal"
        />
      </template>
    </popover>
  </div>
</template>

<script>
import SearchBulkBlockedNumberModal from '../SearchBulkBlockedNumber/SearchBulkBlockedNumberModal.vue';

import messages from '../../locales';
import { mapState, mapActions } from 'vuex';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import { STATUS_ERROR, STATUS_SUCCESS, getStatus } from '@/store/helpers';

import { mixin as clickaway } from 'vue-clickaway';

import { debounce } from 'lodash';

export default {
  components: {
    SearchBulkBlockedNumberModal,
  },
  mixins: [ clickaway ],
  data: function () {
    return {
      showModal: false,
      numberSearched: '',
    };
  },
  computed: {
    ...mapState({
      campaignsMap: (state) => Object.assign({}, ...state.completedCampaignsWithoutStats.map(({id, name}) => ({[id]: {name}}))),
    }),
    ...mapState('blockedNumbers', {
      unblockStatus:  (state) => getStatus(state, 'REMOVE_BULK_BLOCKED_NUMBER'),
    }),
    numberSearchedModel: {
      get: function () {
        return !this.numberSearched || this.numberSearched[0] == '+'
          ? this.numberSearched 
          : '+' + this.numberSearched;
      },
      set: function (val) {
        if (!val || val[0] !== '+') {
          val = '+' + val;
        }
        this.numberSearched = val;
      },
    },
  },
  methods: {
    ...mapActions('blockedNumbers', [
      'searchBulkBlockedNumber',
      'unBlockBulkBlockedNumber',
    ]),
    onSearchNumber: debounce(function() {
      if (this.numberSearched && this.numberSearched.length > 1) {
        this.searchBulkBlockedNumber(this.numberSearched);
        this.showModal = true;
      }
    }, 500),
    async onUnblock() {
      this.hideModal();
      await this.unBlockBulkBlockedNumber({
        number: this.numberSearched,
        deleteType: 'Both',
      });
      if (this.unblockStatus.status === STATUS_SUCCESS) {
        utilities.showToaster('success', this.$i18n.t('UNBLOCK_SUCCESS'));
      }
      if (this.unblockStatus.status === STATUS_ERROR) {
        utilities.errorHandler(this.unblockStatus.error);
      }
    },
    hideModal() {
      this.showModal = false;
    } 
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style  lang="scss">
.popover.search-popover {
  max-width: 30%;
  min-width: 30%;
  left: auto !important;
  right: 0 !important;

  .close {
    margin-top: -4px;
  }

  .popover-title {
    background-color: var(--component-in-app-notifications__popover);
  }
  background-color: var(--component-in-app-notifications__popover);
  &.bottom {
    @include setPopoverArrowColor(
      'border-bottom-color',
      var(--component-in-app-notifications__popover)
    );
    margin-right: 40px;
    .arrow {
      left: 90%;
    }
  }

  &.right {
    @include setPopoverArrowColor(
      'border-right-color',
      var(--component-in-app-notifications__popover)
    );
  }

  .popover-content {
    padding: 1px;
  }
  .form-group {
    padding-right: 0;
    padding-left: 0;
  }

  @media (max-width: 575.98px) {
    max-width: 80%;
    min-width: 80%;
    .close {
      margin-top: -7px;
    }
  }
}
</style>